export default "__VITE_ASSET__V4lpIa0$__"